import { ModerationStatus, } from '@tribeplatform/gql-client/types';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getModerationItemsKey } from '../../utils/keys';
import { removeFromModerationItems } from '../cache';
export const useUpdateModerationItem = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const moderationItemsKey = getModerationItemsKey();
    return useMutation(variables => client.moderation.updateItem(variables), {
        onMutate: variables => {
            var _a, _b;
            if (((_a = variables === null || variables === void 0 ? void 0 : variables.input) === null || _a === void 0 ? void 0 : _a.status) === ModerationStatus.REJECTED ||
                ((_b = variables === null || variables === void 0 ? void 0 : variables.input) === null || _b === void 0 ? void 0 : _b.status) === ModerationStatus.ACCEPTED) {
                removeFromModerationItems(variables.id, queryClient);
            }
        },
        onSettled: () => {
            // invalidate to refetch again
            queryClient.invalidateQueries(moderationItemsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateModerationItem.js.map